export default {
  error: state => state.error,
  success: state => state.success,
  loading: state => state.loading,
  exportLoading: state => state.exportLoading,
  reportLink: state => state.reportLink,
  coownerSectionLink: state => state.coownerSectionLink,
  soi: state => state.soi,
  generalLedger: state => state.generalLedger,
  balanceSheet: state => state.balanceSheet,
  drd: state => state.drd,
  drdLink: state => state.drdLink,
  drdExportLink: state => state.drdExportLink,
  downloadIncStmtLink: state => state.downloadIncStmtLink,
  downloadGLLink: state => state.downloadGLLink,
  downloadBalanceSheetLink: state => state.downloadBalanceSheetLink,
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Reports/getters.js